import React from 'react';
import { X } from 'lucide-react';
import { BarIconB } from './BarIconB';

/** A Studio B side panel's header: its name (and a count), then its own actions and Close, as the bar's icon buttons. */
export function PanelHeaderB({ title, count, onClose, children }: { title: string; count?: number; onClose: () => void; children?: React.ReactNode }) {
  return (
    <div className="flex h-[var(--b-panel-header)] flex-shrink-0 items-center justify-between gap-2 border-b border-b-line pl-4 pr-2">
      <h2 className="min-w-0 truncate text-b-label text-b-t1">
        {title}
        {count ? <span className="ml-1.5 text-b-meta text-b-t3">{count}</span> : null}
      </h2>
      <div className="flex flex-shrink-0 items-center gap-0.5">
        {children}
        <BarIconB label={`Close ${title.toLowerCase()}`} onClick={onClose}>
          <X className="h-4 w-4" />
        </BarIconB>
      </div>
    </div>
  );
}
